export default "__VITE_ASSET__DOuuL3Jb__"